module.exports = __webpack_public_path__ + "06b8f05c2c2a9c83dde97f1145ba0a01.pdf";